import { Suspense } from 'react';
import { Center, CustomSpinner } from '~/commonComponents';
import { PDFPreviewConsent } from '~/commonComponents/PDFPreviewConsent';

export const SignUpTermsAndConditions = ({
  handleAccept,
  pdfUrl,
  isLoading,
}: {
  handleAccept: () => void;
  pdfUrl: string;
  isLoading: boolean
}) => {
  return (
    <Suspense
      fallback={
        <div className="component_container">
          <div
            className="floating_container"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginInline: '20px',
            }}
          >
            <Center marginTop={40}>
              <CustomSpinner isLoading />
            </Center>
          </div>
        </div>
      }
    >
      <PDFPreviewConsent
        pdfUrl={pdfUrl}
        isAccepting={false}
        isLoading={isLoading}
        onConsent={handleAccept}
        minHeight={'100vh'}
      />
    </Suspense>
  );
};
